export default {
    scanned: [],
    connected: {},
    terminalData: [],
    tab: 'bluetooth',
    isEnableBtTab: false,
    isEnableUsbTab: false,
    isEnableUpdateOs: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/device/state.js